import { useEffect } from "react"; // 1. Import useEffect
import { useDispatch } from "react-redux";
import useAwaitableComponent from "use-awaitable-component";
import { DIALOG_ACTIVE, DIALOG_INACTIVE } from "../constants/actions"; // 2. Assuming you have a cleanup action

const useAwaitDialog = () => {
    const [status, execute, resolve, reject, reset] = useAwaitableComponent();
    const dispatch = useDispatch();

    // ✅ SOLUTION: The dispatch is now wrapped in a useEffect hook.
    useEffect(() => {
        // This code runs *after* the component mounts (renders for the first time).
        dispatch({ type: DIALOG_ACTIVE, awaitComponentData: { status, execute, resolve, reject, reset } });

        // 3. Return a cleanup function.
        // This runs when the component that uses this hook unmounts.
        return () => {
            dispatch({ type: DIALOG_INACTIVE }); // Or a reset action
        };
        // 4. The dependency array includes all values from the hook's scope.
        // This ensures the effect re-runs if any of these functions/values change.
    }, [dispatch, status]);


    return { execute, reset };
}

export default useAwaitDialog;
